import { useMemo } from "react";
import PageLayout from "@/layouts/PageLayout";
import { useTranslation } from "react-i18next";

import { useCRMConnectionsStatus } from "@/hooks/api/crm/useCRMConnectionsStatus";
import AllCRMGrid from "@/components/organisms/crm/AllCRMGrid";

const CRMPage = () => {
  const { t } = useTranslation();

  const { data: hubspotCRM, isLoading } = useCRMConnectionsStatus({});
  const isConnected = useMemo(() => hubspotCRM?.hubspot.connected && !hubspotCRM?.hubspot.error, [hubspotCRM]);

  return (
    <PageLayout>
      <div className={"mb-10"}>
        <h2 className={"text-2xl font-semibold text-primary"}>{t("crm.settings.title")}</h2>
        <p className={"max-w-lg text-sm text-quaternary"}>{t("crm.settings.description")}</p>
      </div>

      {isLoading ? (
        <>
          <div className={"mb-6 h-5 w-48 animate-pulse rounded-full bg-gray-300"} />
          <div className={"grid grid-cols-2 gap-6 xl:grid-cols-4"}>
            <div className={"h-60 w-full animate-pulse rounded-lg bg-gray-300"} />
          </div>
        </>
      ) : isConnected ? (
        <>
          <h3 className={"mb-6 font-medium text-primary"}>{t("crm.settings.connected")}</h3>
          <AllCRMGrid className={"mb-6 grid grid-cols-2 gap-6 xl:grid-cols-4"} />
        </>
      ) : (
        <>
          <h3 className={"mb-6 font-medium text-primary"}>{t("crm.settings.setup")}</h3>
          <AllCRMGrid className={"grid grid-cols-2 gap-6 xl:grid-cols-4"} />
        </>
      )}
    </PageLayout>
  );
};

export default CRMPage;
